import React from 'react';
import moment from 'moment';
import UIHelper from 'helpers/UIHelper';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const lookup = (options, value) => {
  const match = options?.find(
    (o) => String(o.value) === String(value) || o.title === value,
  );
  return display(match?.title ?? value);
};

export const getCalendarRowViewFields = (t, row, backendFilters = {}) => {
  const calendarDate = row?.calendar_date
    ? UIHelper.formatedDate(row.calendar_date, 'DD MMMM YYYY')
    : '—';

  return [
    {
      text: t('Settimana'),
      value: row?.week_day ? `${t('Settimana')} ${row.week_day}` : '—',
    },
    { text: t('Data'), value: calendarDate },
    {
      text: t('Giorno'),
      value: row?.day ? (
        <span style={{ textTransform: 'capitalize' }}>{row.day}</span>
      ) : (
        '—'
      ),
    },
    {
      text: t('Aperture'),
      value: lookup(backendFilters?.type_closes, row?.type_close),
    },
    {
      text: t('Tipo Giorno'),
      value: lookup(backendFilters?.day_types, row?.day_type),
    },
    { text: t('Footfall'), value: display(row?.footfall) },
    {
      text: t('Trading calendar'),
      value: lookup(
        backendFilters?.by_calendar_categories,
        row?.analytics_calendar_category_id,
      ),
    },
    { text: t('Note'), value: display(row?.comment) },
  ];
};

export const getViewPeriodTitle = (date, groupBy, t) => {
  if (!date) {
    return t('FOOTFALL E CALENDARIO');
  }
  switch (groupBy) {
    case 'day':
      return UIHelper.formatedDate(date, 'DD MMMM YYYY');
    case 'week':
      return `${t('Settimana')} ${moment(date).isoWeek()}, ${UIHelper.formatedDate(
        date,
        'YYYY',
      )}`;
    case 'month':
      return UIHelper.formatedDate(date, 'MMMM YYYY');
    case 'year':
      return UIHelper.formatedDate(date, 'YYYY');
    default:
      return `${t('Settimana')} ${moment(date).isoWeek()}, ${UIHelper.formatedDate(
        date,
        'YYYY',
      )}`;
  }
};
